module.exports = function() {
  return new Worker(__webpack_public_path__ + "4ddeb25e05f15d7ba964.worker.js");
};